var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"normal-btn",attrs:{"color":_vm.color,"block":_vm.block,"large":_vm.large,"small":_vm.small,"outlined":_vm.outlined},on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-logout")]),_vm._v(" "+_vm._s(_vm.$t('entrance.logout'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }